import { Channel, Shape } from "@kosmod/pancake";
import { Actions, SceneSessionAction } from "./actions";
import { Events, SceneSessionEvent } from "./events";

export type SceneSessionChannel = Channel.Type<SceneSessionAction, SceneSessionEvent>;
export const SceneSessionChannel = {
  Actions,
  Events,
}